/* Bambus+ — tilmelding og udmelding.
   Sender til /apps/klub/… paa butikkens eget domaene. Shopify (app proxy) sender videre til appens
   server og signerer kaldet, saa serveren ved at det kommer fra butikken. Fire sprog. */
(function () {
  var SPROG = (window.KLUB_SPROG || 'da').slice(0, 2);
  // A/B-test af pop-uppen (1/10-2026): knappen i pop-up B linker hertil med ?fra=popup-b. Huskes i fanen.
  var FRA = '';
  try {
    var q = (location.search.match(/[?&]fra=([a-z0-9-]{1,20})/) || [])[1];
    if (q) sessionStorage.setItem('klub_fra', q);
    FRA = q || sessionStorage.getItem('klub_fra') || '';
  } catch (e) {}
  // Test 2 (2/10-2026): pop-up mod ingen pop-up. Pop-uppens script giver browseren gruppe a eller 0 (tac_ab2).
  try {
    var G = localStorage.getItem('tac_ab2');
    // Linkene til Bliv medlem har selv ?fra= (vareside, mobilmenu ...), saa gruppen saettes BAG paa: vareside-g0.
    // Rettet 4/10-2026: foer blev gruppen kun sendt uden anden fra, og saa kom ingen indmeldelser med i testen.
    if (G === 'a' || G === '0') FRA = (FRA ? FRA.slice(0, 16) : 'bliv') + '-g' + G;
  } catch (e) {}
  var TEKST = {
    da: { opretter: 'Opretter din konto', fejl: 'Noget gik galt. Prøv igen.', server: 'Vi kunne ikke få fat i serveren. Prøv igen om et øjeblik.',
          sms: 'Du er tilmeldt nyhedsbrev og SMS. Du kan altid afmelde dig igen og beholder din bonus.',
          mail: 'Du er tilmeldt nyhedsbrevet. Vil du også have SMS, kan du tilføje dit nummer senere.',
          allerede: 'Du er allerede medlem. Log ind og se din bonus.', mange: 'Du har prøvet flere gange. Vent et øjeblik og prøv igen.',
          melder_ud: 'Sletter din konto', udmeldt: 'Din konto er slettet. Tak for tiden i klubben.', km_fra: 'Du får ikke flere mails fra Bambus+. Din bonus og rabat fortsætter.', sms_fra: 'Du er afmeldt SMS. Du er stadig medlem.', nb_fra: 'Du er afmeldt nyhedsbrevet. Du er stadig medlem og får fortsat mails fra Bambus+.',
          ikke_nu: 'Det kunne vi ikke lige nu. Prøv igen om et øjeblik.', hvem: 'Vi kunne ikke se, hvem du er. Prøv at logge ind igen.' },
    sv: { opretter: 'Skapar ditt konto', fejl: 'Något gick fel. Försök igen.', server: 'Vi kunde inte nå servern. Försök igen om en stund.',
          sms: 'Du får nyhetsbrev och sms. Du kan alltid avregistrera dig och behåller din bonus.',
          mail: 'Du får vårt nyhetsbrev. Vill du också få sms kan du lägga till ditt nummer senare.',
          allerede: 'Du är redan medlem. Logga in och se din bonus.', mange: 'Du har försökt flera gånger. Vänta en stund och försök igen.',
          melder_ud: 'Raderar ditt konto', udmeldt: 'Ditt konto är raderat. Tack för tiden i klubben.', km_fra: 'Du får inga fler mejl från Bambus+. Din bonus och rabatt fortsätter.', sms_fra: 'Du är avregistrerad från sms. Du är fortfarande medlem.', nb_fra: 'Du är avregistrerad från nyhetsbrevet. Du är fortfarande medlem och får mejl från Bambus+.',
          ikke_nu: 'Det gick inte just nu. Försök igen om en stund.', hvem: 'Vi kunde inte se vem du är. Logga in igen.' },
    de: { opretter: 'Dein Konto wird erstellt', fejl: 'Etwas ist schiefgelaufen. Bitte versuche es erneut.', server: 'Wir konnten den Server nicht erreichen. Bitte versuche es gleich noch einmal.',
          sms: 'Du erhältst Newsletter und SMS. Du kannst dich jederzeit abmelden und behältst dein Guthaben.',
          mail: 'Du erhältst unseren Newsletter. Wenn du auch SMS möchtest, kannst du deine Nummer später hinzufügen.',
          allerede: 'Du bist bereits Mitglied. Melde dich an und sieh dein Guthaben.', mange: 'Du hast es mehrmals versucht. Bitte warte kurz.',
          melder_ud: 'Konto wird gelöscht', udmeldt: 'Dein Konto ist gelöscht. Danke für die Zeit im Club.', km_fra: 'Du bekommst keine E-Mails mehr von Bambus+. Dein Guthaben und Rabatt bleiben.', sms_fra: 'Du bist von SMS abgemeldet. Du bist weiterhin Mitglied.', nb_fra: 'Du bist vom Newsletter abgemeldet. Du bist weiterhin Mitglied und bekommst E-Mails von Bambus+.',
          ikke_nu: 'Das hat gerade nicht geklappt. Bitte versuche es gleich noch einmal.', hvem: 'Wir konnten nicht erkennen, wer du bist. Bitte melde dich erneut an.' },
    en: { opretter: 'Creating your account', fejl: 'Something went wrong. Please try again.', server: 'We could not reach the server. Please try again in a moment.',
          sms: 'You will receive our newsletter and text messages. You can always unsubscribe and keep your credit.',
          mail: 'You will receive our newsletter. If you also want text messages, you can add your number later.',
          allerede: 'You are already a member. Log in to see your credit.', mange: 'You have tried several times. Please wait a moment.',
          melder_ud: 'Deleting your account', udmeldt: 'Your account has been deleted. Thank you for your time in the club.', km_fra: 'You will not get more emails from Bambus+. Your credit and discount continue.', sms_fra: 'You have unsubscribed from text messages. You are still a member.', nb_fra: 'You have unsubscribed from the newsletter. You are still a member and will keep getting emails from Bambus+.',
          ikke_nu: 'That did not work right now. Please try again in a moment.', hvem: 'We could not tell who you are. Please log in again.' }
  };
  var T = TEKST[SPROG] || TEKST.da;
  window.KLUB_TEKST = T;

  var form = document.getElementById('klub-form');
  if (!form) return;

  var mail  = document.getElementById('klub-mail');
  var mobil = document.getElementById('klub-mobil');
  var fMail = document.getElementById('klub-f-mail');
  var fMob  = document.getElementById('klub-f-mobil');
  var knap  = document.getElementById('klub-knap');
  var kvit  = document.getElementById('klub-kvit');

  function gyldigMail(v) { return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test((v || '').trim()); }
  function gyldigMobil(v) {
    var r = (v || '').replace(/[\s\-()]/g, '');
    if (r === '' || r === '+' || r === '+45' || r === '+46' || r === '+49') return true;
    return /^(\+\d{8,15}|\d{8})$/.test(r);
  }
  function fejl(felt, vis) { if (felt) felt.classList.toggle('klub-fejl', !!vis); }

  if (mail && fMail) mail.addEventListener('input', function () {
    if (gyldigMail(mail.value)) fejl(fMail, false);
  });
  mobil.addEventListener('input', function () {
    if (gyldigMobil(mobil.value)) fejl(fMob, false);
  });

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var ok = true;
    if (fMail && !gyldigMail(mail.value)) { fejl(fMail, true); ok = false; }
    if (!gyldigMobil(mobil.value)) { fejl(fMob, true); ok = false; }
    if (!ok) { (fMail && fMail.classList.contains('klub-fejl') ? mail : mobil).focus(); return; }

    knap.disabled = true;
    var oprindelig = knap.textContent;
    knap.textContent = T.opretter;
    var nummer = mobil.value.trim();
    if (nummer === '+') nummer = '';

    fetch((window.KLUB_ENDPOINT || '/apps/klub') + '/tilmeld', {
      method: 'POST',
      headers: { 'content-type': 'application/json' },
      body: JSON.stringify({ mail: mail.value.trim(), mobil: nummer, sprog: SPROG, fra: FRA })
    })
      .then(function (r) { return r.json().then(function (d) { return { s: r.status, d: d }; }); })
      .then(function (x) {
        if (x.d && x.d.allerede) {
          knap.disabled = false; knap.textContent = oprindelig;
          alert(T.allerede); return;
        }
        if (x.s !== 200 || !x.d.medlem) {
          knap.disabled = false;
          knap.textContent = oprindelig;
          if (x.d && x.d.felt === 'mail') { fejl(fMail, true); }
          else if (x.d && x.d.felt === 'mobil') { fejl(fMob, true); }
          else if (x.s === 429) { alert(T.mange); }
          else { alert(T.fejl); }
          return;
        }
        document.getElementById('klub-viskode').textContent = x.d.kode || '—';
        document.getElementById('klub-naeste').textContent = x.d.sms ? T.sms : T.mail;
        form.classList.add('klub-skjul');
        kvit.classList.add('klub-vis');
        kvit.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
      })
      .catch(function () {
        knap.disabled = false;
        knap.textContent = oprindelig;
        alert(T.server);
      });
  });
})();


/* Slet min konto (Michael 1/10-2026: klubmails kan ikke fravaelges; vil man ud, sletter man kontoen). To trin. */
(function () {
  var knap = document.getElementById('klub-udmeld');
  if (!knap) return;
  var T = window.KLUB_TEKST || {};
  var boks = document.getElementById('klub-bekraeft');
  var ja   = document.getElementById('klub-udmeld-ja');
  var nej  = document.getElementById('klub-fortryd');
  var note = document.getElementById('klub-udmeld-note');

  function vis(t) { note.textContent = t; note.hidden = false; }

  knap.addEventListener('click', function () {
    boks.hidden = false;
    knap.hidden = true;
    nej.focus();
  });

  nej.addEventListener('click', function () {
    boks.hidden = true;
    knap.hidden = false;
    knap.focus();
  });

  ja.addEventListener('click', function () {
    ja.disabled = true;
    ja.textContent = T.melder_ud;

    /* Gaar gennem Shopifys app proxy, saa Shopify selv fortaeller hvem kunden er.
       Kunde-id maa ALDRIG komme fra browseren — saa kunne man melde andre ud. */
    fetch((window.KLUB_ENDPOINT || '/apps/klub') + '/slet-konto', {
      method: 'POST',
      headers: { 'content-type': 'application/json' },
      body: '{}'
    })
      .then(function (r) { return r.json().then(function (d) { return { s: r.status, d: d }; }); })
      .then(function (x) {
        boks.hidden = true;
        if (x.s === 200 && x.d.ok) {
          vis(T.udmeldt);
          setTimeout(function () { window.location.href = '/account/logout'; }, 3500);
        } else {
          knap.hidden = false;
          vis(x.s === 403 ? T.hvem : T.ikke_nu);
        }
      })
      .catch(function () {
        boks.hidden = true;
        knap.hidden = false;
        vis(T.ikke_nu);
      });
  });
})();


/* Afmeld nyhedsbrev eller SMS fra kontoen. Medlemskab og klubmails fortsaetter. */
function klubFra(id, sti, note_id, status_id, tekst) {
  var knap = document.getElementById(id);
  if (!knap) return;
  var T = window.KLUB_TEKST || {};
  knap.addEventListener('click', function () {
    knap.disabled = true;
    fetch((window.KLUB_ENDPOINT || '/apps/klub') + sti, {
      method: 'POST', headers: { 'content-type': 'application/json' }, body: '{}'
    })
      .then(function (r) { return r.json().then(function (d) { return { s: r.status, d: d }; }); })
      .then(function (x) {
        var note = document.getElementById(note_id);
        if (x.s === 200 && x.d.ok) {
          knap.hidden = true;
          var st = document.getElementById(status_id);
          if (st) { st.textContent = st.getAttribute('data-fra'); st.className = 'klub-tilstand klub-fra'; }
          if (note) { note.textContent = tekst(T); note.hidden = false; }
        } else {
          knap.disabled = false;
          if (note) { note.textContent = x.s === 403 ? T.hvem : T.ikke_nu; note.hidden = false; }
        }
      })
      .catch(function () { knap.disabled = false; });
  });
}
klubFra('klub-nb-fra', '/nyhedsbrev-fra', 'klub-nb-note', 'klub-nb-status', function (T) { return T.nb_fra; });
klubFra('klub-sms-fra', '/sms-fra', 'klub-sms-note', 'klub-sms-status', function (T) { return T.sms_fra; });
klubFra('klub-km-fra', '/klubmails-fra', 'klub-km-note', 'klub-km-status', function (T) { return T.km_fra; });
